import { connect } from 'react-redux';

import { resetParticipantRender } from 'api/events/events.actions';
import { ResetRenderModalContent } from './ResetRenderModalContent';
import { ResetParticipantRenderBody } from 'api/events/events.types';

const mapDispatchToProps = (dispatch: Function) => ({
  resetParticipantRender: (eventId: string, body: ResetParticipantRenderBody) =>
    dispatch(resetParticipantRender(eventId, body)),
});

export const ResetRenderModalContentContainer = connect(null, mapDispatchToProps)(ResetRenderModalContent);
